module.exports = __webpack_public_path__ + "img/four1Blue.e4740bc3.png";